export default __webpack_public_path__ + "cb2a7335650c690077fef78a44129e1b.woff2";